var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentLinks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 0V10H9.75V7.14286H11.25V8.57143H16.5V1.42857H11.25V2.85714H9.75V0H17.9999Z",
    fill: "#C2C0BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24994 0V2.85714H6.74995V1.42857H1.49999V8.57143H6.74995V7.14286H8.24994V10H0V0H8.24994Z",
    fill: "#C2C0BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2499 4.28577H3.75V5.71434H14.2499V4.28577Z",
    fill: "#C2C0BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLinks);
export default __webpack_public_path__ + "static/media/payment-links.e72ceb20.svg";
export { ForwardRef as ReactComponent };